import { Navigate, useSearchParams } from 'react-router-dom';

const PreserveSearchNavigate = ({ to }: { to: string }) => {
	const [searchParams] = useSearchParams();
	const search = searchParams.toString();
	return (
		<Navigate
			to={{
				pathname: to,
				search: search.length > 0 ? `?${search}` : '',
			}}
			replace
		/>
	);
};

export default PreserveSearchNavigate;
